import { render } from "./ArticoleFavorite.vue?vue&type=template&id=4f19b2a0&scoped=true&ts=true"
import script from "./ArticoleFavorite.ts?vue&type=script&lang=ts"
export * from "./ArticoleFavorite.ts?vue&type=script&lang=ts"

import "./ArticoleFavorite.vue?vue&type=style&index=0&id=4f19b2a0&scoped=true&lang=scss"

import exportComponent from "D:\\ColorMetalBG\\cmportal-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f19b2a0"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QLinearProgress,QImg,QBtn,QTooltip});
